<template>
  <div style="padding: 1vw">
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 1vw;
      "
    >
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          병원 계정 관리
        </h3>
        <span class="pageDesc">
          병원 페이지에 접속한 계정을 조회하고 관리할 수 있습니다.
        </span>
      </div>
      <div style="display: flex; align-items: center">
        <button class="btn btn-primary" type="button" @click="downloadExcel()">
          엑셀 내려받기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div class="searchdropbox" />
      <div class="searchinputbox">
        <select
          v-model="accountTypeFilter"
          id="accountTypeFilter"
          @change="enter()"
        >
          <option value="" selected>계정 유형 전체</option>
          <option value="ADMIN">관리자 계정</option>
          <option value="MEMBER">서브 계정</option>
        </select>
        <select v-model="searchFilter" id="itemCode">
          <option value="" selected>선택</option>
          <option value="corpName">병원명</option>
          <option value="name">관리자명</option>
          <option value="username">관리자 아이디</option>
        </select>
        <input
          type="text"
          placeholder="조건을 입력해주세요."
          v-model="condition"
          ref="cdInput"
          id=""
          autocomplete="off"
          @keyup.enter="enter()"
          :readonly="!isFocused"
          @focus="isFocused = true"
        />
        <div class="searchBtn">
          <img
            src="../../assets/img/search.png"
            alt="search"
            class="hoverPointer"
            @click="enter()"
          />
        </div>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select
          class="search-select"
          v-model="rowsPerPage"
          @change="handleRowsPerPage"
        >
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
          <option :value="100">100개씩 보기</option>
        </select>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
        @change="handleTableChange"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination
        :page-info="paginationData"
        page-name="CustomerManage"
        @change-page="paginationHandler"
      />
    </div>
    <!-- <div class="py-4 container-fluid card" style="width: 98%; margin: 1vw">
      <div class="kdh_table_div table-responsive p-0">
        <div v-if="responseData.length === 0" class="noResult">검색 결과가 없습니다.</div>
        <table v-else class="kdh_table table align-items-center mb-0">
          <colgroup>
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
            <col width="10%" />
          </colgroup>
          <thead >
            <th class="text-uppercase text-secondary font-weight-bolder">
              병원명
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              관리자명
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              관리자 ID
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              IP
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              접속 기기
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              최근 접속 시간
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              최초 접속 시간
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              비밀번호
            </th>
            <th class="text-uppercase text-secondary font-weight-bolder">
              관리
            </th>
          </thead>
          <tbody>
            <tr scope="row" v-for="(item, i) in responseData" :key="i">
              <td>{{ item.corpName }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.ip || '-' }}</td>
              <td>{{ item.agent || '-' }}</td>
              <td>{{ convertDate(item.lastLoginAt) }}</td>
              <td>{{ convertDate(item.firstLoginAt) }}</td>
              <td style="padding: 0.7vw">
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#resetyesno"
                  @click="selectHospital(item)"
                >
                  초기화
                </button>
              </td>
              <td style="padding: 0.7vw">
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#logoutyesno"
                  @click="selectHospital(item)"
                  >
                  연결해제
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->
    <!-- 삭제 모달 -->
    <div
      class="modal fade"
      id="logoutyesno"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>계정 연결 해제</h4>
              <h6>해당 계정을 로그아웃 처리하시겠습니까?</h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-primary"
                @click="logoutUser()"
              >
                연결 해제
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 초기화 모달 -->
    <div
      class="modal fade"
      id="resetyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>비밀번호 초기화</h4>
              <h6>임시 비밀번호는 관리자 ID와 동일합니다.</h6>
              <h6>초기화하시겠습니까?</h6>
            </div>
            <div
              style="display: flex; justify-content: center; margin-top: 2rem"
            >
              <button
                style="margin-right: 1vw"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                data-bs-dismiss="modal"
                @click="resetPassword()"
              >
                초기화
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 관리자 계정 수정 모달 -->
    <a-modal
      v-model:visible="editModalVisible"
      :confirm-loading="editLoading"
      :footer="null"
      @cancel="cancelEdit"
    >
      <template #title>
        <div class="modal-title">관리자 계정 수정</div>
      </template>

      <div class="modal-content">
        <a-form layout="vertical" :model="formEdit" ref="editForm">
          <a-form-item
            label="새 관리자 ID"
            name="username"
            :rules="[
              { required: true, message: '새로운 관리자 ID를 입력하세요' },
            ]"
          >
            <a-input
              v-model:value="formEdit.username"
              placeholder="새로운 관리자 ID를 입력하세요"
              @change="handleUsernameChange"
            />
          </a-form-item>

          <a-divider />

          <!-- 비밀번호 변경 섹션 -->
          <div class="password-section">
            <h4 style="margin-bottom: 16px; font-size: 14px; font-weight: 600">
              비밀번호 변경
            </h4>

            <a-form-item label="새 비밀번호" name="newPassword">
              <a-input-password
                v-model:value="formEdit.newPassword"
                placeholder="새 비밀번호를 입력하세요 (선택사항)"
                @change="handlePasswordChange"
              />
              <div v-if="formEdit.newPassword" class="password-hint">
                <small style="color: #666">
                  • 8자 이상 입력하세요<br />
                  • 영문, 숫자, 특수문자를 포함하세요
                </small>
              </div>
            </a-form-item>

            <a-form-item
              v-if="formEdit.newPassword"
              label="비밀번호 확인"
              name="confirmPassword"
            >
              <a-input-password
                v-model:value="formEdit.confirmPassword"
                placeholder="비밀번호를 다시 입력하세요"
                @change="handlePasswordChange"
              />
              <div
                v-if="
                  formEdit.confirmPassword &&
                  formEdit.newPassword !== formEdit.confirmPassword
                "
                class="password-error"
              >
                <small style="color: #ff4d4f"
                  >비밀번호가 일치하지 않습니다</small
                >
              </div>
            </a-form-item>
          </div>

          <!-- 서브계정 권한 설정 섹션 -->
          <template v-if="editedRecord.accountType === 'MEMBER'">
            <a-divider />
            <div class="permission-section">
              <h4
                style="margin-bottom: 16px; font-size: 14px; font-weight: 600"
              >
                권한 설정
              </h4>

              <a-spin :spinning="editDetailLoading">
                <div
                  v-if="Object.keys(availableCategories).length > 0"
                  class="permission-groups"
                >
                  <!-- 발행 관련 권한 -->
                  <div
                    v-if="
                      availableCategories.issue &&
                      availableCategories.issue.length > 0
                    "
                    class="permission-group"
                  >
                    <div class="permission-group-title">발행</div>
                    <div class="permission-group-items">
                      <label
                        v-for="category in availableCategories.issue"
                        :key="category.value"
                        class="permission-item"
                      >
                        <input
                          type="checkbox"
                          :checked="
                            formEdit.allowedCategories.includes(category.value)
                          "
                          @change="
                            (e) =>
                              handlePermissionChange(
                                category.value,
                                e.target.checked
                              )
                          "
                        />
                        <span class="permission-label">{{
                          category.label
                        }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- 설정 관련 권한 -->
                  <div
                    v-if="
                      availableCategories.settings &&
                      availableCategories.settings.length > 0
                    "
                    class="permission-group"
                  >
                    <div class="permission-group-title">설정</div>
                    <div class="permission-group-items">
                      <label
                        v-for="category in availableCategories.settings"
                        :key="category.value"
                        class="permission-item"
                      >
                        <input
                          type="checkbox"
                          :checked="
                            formEdit.allowedCategories.includes(category.value)
                          "
                          @change="
                            (e) =>
                              handlePermissionChange(
                                category.value,
                                e.target.checked
                              )
                          "
                        />
                        <span class="permission-label">{{
                          category.label
                        }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- 운영 관련 권한 -->
                  <div
                    v-if="
                      availableCategories.operation &&
                      availableCategories.operation.length > 0
                    "
                    class="permission-group"
                  >
                    <div class="permission-group-title">운영</div>
                    <div class="permission-group-items">
                      <label
                        v-for="category in availableCategories.operation"
                        :key="category.value"
                        class="permission-item"
                      >
                        <input
                          type="checkbox"
                          :checked="
                            formEdit.allowedCategories.includes(category.value)
                          "
                          @change="
                            (e) =>
                              handlePermissionChange(
                                category.value,
                                e.target.checked
                              )
                          "
                        />
                        <span class="permission-label">{{
                          category.label
                        }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- 기타 권한 -->
                  <div
                    v-if="
                      availableCategories.other &&
                      availableCategories.other.length > 0
                    "
                    class="permission-group"
                  >
                    <div class="permission-group-title">기타</div>
                    <div class="permission-group-items">
                      <label
                        v-for="category in availableCategories.other"
                        :key="category.value"
                        class="permission-item"
                      >
                        <input
                          type="checkbox"
                          :checked="
                            formEdit.allowedCategories.includes(category.value)
                          "
                          @change="
                            (e) =>
                              handlePermissionChange(
                                category.value,
                                e.target.checked
                              )
                          "
                        />
                        <span class="permission-label">{{
                          category.label
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div v-else class="no-permissions">
                  선택 가능한 권한이 없습니다.
                </div>
              </a-spin>
            </div>
          </template>
        </a-form>

        <div class="modal-footer">
          <a-button @click="cancelEdit">취소</a-button>
          <a-button
            type="primary"
            @click="confirmEdit"
            :loading="editLoading"
            :disabled="!isFormValid"
            class="yellow-button"
            >확인</a-button
          >
        </div>
      </div>
    </a-modal>

    <!-- 2차 인증 창(상태·예외·잠금·초기화·이력, REQ-ACC-012) -->
    <account-security-modal
      :account="securityAccount"
      @close="securityAccount = null"
    />
  </div>
</template>
<script>
import { convertDate, openDialog, convertDateTime } from "@/utils/utils";
import Pagination from "@/views/components/Pagination.vue";
import AccountSecurityModal from "@/views/components/AccountSecurityModal.vue";
import dayjs from "dayjs";
import { isSupportRow, supportBadge } from "@/utils/accountRows";

export default {
  name: "hosAccManage",
  components: {
    Pagination,
    AccountSecurityModal,
  },
  data() {
    return {
      convertDateTime,
      type: "HOSPITAL", // API호출용 유저 종류

      // 목록 받아오는 변수
      responseData: [],

      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      page: 1,
      totalPages: 0, // Total number of pages, fetched from server
      pageSize: 0, // Same as totalPages
      paginationPageAmount: 10, // Default, can be variable
      paginationList: [],
      isFirstPage: true,
      isFirstBlock: true,
      isLastBlock: false,
      isLastPage: false,

      selectedHospital: {}, // 선택된 병원 정보
      securityAccount: null, // 「2차 인증」 창을 연 행
      isFocused: false, // 자동완성 때문에 최초엔 폴스로

      searchFilter: "corpName", // 검색 필터의 기본값을 "병원명"으로 변경
      condition: "", // 검색어
      accountTypeFilter: "", // 계정 유형 필터 (ADMIN: 마스터, MEMBER: 서브)
      sort: {
        //소트
        parameter: "lastLoginAt",
        method: "DESC",
      },

      paginationData: {
        currentPage: 1,
        totalPages: 0,
      },
      columns: [
        {
          key: "corpName",
          title: "병원명",
          dataIndex: "corpName",
          align: "center",
        },
        { key: "name", title: "관리자명", dataIndex: "name", align: "center" },
        {
          key: "username",
          title: "관리자 ID",
          dataIndex: "username",
          align: "center",
        },
        {
          key: "accountType",
          title: "계정 유형",
          dataIndex: "accountType",
          align: "center",
          customRender: ({ record }) => {
            return this.getAccountTypeLabel(record.accountType);
          },
        },
        { key: "ip", title: "IP", dataIndex: "ip", align: "center" },
        {
          key: "agent",
          title: "접속 기기",
          dataIndex: "agent",
          align: "center",
        },
        {
          key: "lastLoginAt",
          title: "최근 접속 시간",
          dataIndex: "lastLoginAt",
          align: "center",
          sorter: (a, b) =>
            dayjs(a.lastLoginAt).unix() - dayjs(b.lastLoginAt).unix(),
          customRender: ({ record }) => {
            return this.convertDateTime(record.lastLoginAt);
          },
        },
        {
          key: "firstLoginAt",
          title: "최초 접속 시간",
          dataIndex: "firstLoginAt",
          align: "center",
          sorter: (a, b) =>
            dayjs(a.firstLoginAt).unix() - dayjs(b.firstLoginAt).unix(),
          customRender: ({ record }) => {
            return this.convertDateTime(record.firstLoginAt);
          },
        },
        {
          key: "manage",
          title: "관리",
          dataIndex: "manage",
          align: "center",
          // 지원 서브 계정 행(support 칸)은 배지만 — 수정·초기화·2차 인증 버튼 없음(서버도 403, W6 A6)
          customRender: ({ record }) => isSupportRow(record) ? (
            <span class="support-badge">{supportBadge(record)}</span>
          ) : (
            <div style="display: flex; gap: 8px; justify-content: center;">
              {supportBadge(record) ? <span class="support-badge">{supportBadge(record)}</span> : null}
              <div
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#resetyesno"
                class="certi-custom-btn"
                onClick={() => {
                  this.selectHospital(record);
                }}
              >
                비밀번호 초기화
              </div>
              <div
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#logoutyesno"
                class="certi-custom-btn"
                onClick={() => {
                  this.selectHospital(record);
                }}
              >
                연결해제
              </div>
              <div
                type="button"
                class="certi-custom-btn"
                style="white-space: nowrap"
                onClick={() => {
                  this.securityAccount = record;
                }}
              >
                2차 인증
              </div>
              <div
                type="button"
                class="certi-custom-btn"
                onClick={() => {
                  this.editHospital(record);
                }}
              >
                수정
              </div>
            </div>
          ),
        },
      ],
      formEdit: {
        username: "",
        newPassword: "",
        confirmPassword: "",
        allowedCategories: [], // 서브계정 권한 설정
      },
      editedRecord: {},
      editModalVisible: false,
      editLoading: false,
      availableCategories: {}, // 선택 가능한 권한 카테고리 목록
      editDetailLoading: false, // 상세 조회 로딩 상태
    };
  },

  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    await this.paginationHandler(obj);
  },
  computed: {
    isFormValid() {
      // ID는 필수이고, 비밀번호는 선택사항
      const hasValidUsername =
        this.formEdit.username && this.formEdit.username.trim() !== "";

      // 비밀번호를 입력했다면 유효성 검사
      if (this.formEdit.newPassword) {
        const isPasswordValid = this.validatePassword(
          this.formEdit.newPassword
        );
        const doPasswordsMatch =
          this.formEdit.newPassword === this.formEdit.confirmPassword;
        return hasValidUsername && isPasswordValid && doPasswordsMatch;
      }

      // 비밀번호를 입력하지 않았다면 ID만 체크
      return hasValidUsername;
    },
  },
  methods: {
    validatePassword(password) {
      if (!password) return false;

      // 8자 이상
      if (password.length < 8) return false;

      // 영문 포함
      if (!/[a-zA-Z]/.test(password)) return false;

      // 숫자 포함
      if (!/[0-9]/.test(password)) return false;

      // 특수문자 포함
      if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return false;

      return true;
    },
    handlePasswordChange() {
      // 비밀번호 입력 시 실시간 유효성 검사
      this.$forceUpdate();
    },
    async handleTableChange(pagination, filters, sorter, extra) {
      if (extra.action == "sort" && sorter.order) {
        this.sort = {
          parameter: sorter.field,
          method:
            sorter.order == "ascend"
              ? "ASC"
              : sorter.order == "descend"
              ? "DESC"
              : "",
        };
      } else if (extra.action == "sort" && !sorter.order) {
        this.sort = {
          parameter: "lastLoginAt",
          method: "DESC",
        };
      }
      const obj = {};
      obj.page = this.paginationData.currentPage;
      this.paginationHandler(obj);
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getHospitalAccountList();
    },
    async enter() {
      this.paginationData.currentPage = 1;
      await this.getHospitalAccountList();
    },

    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 주요 API

    // 전체 목록 가져오기
    async getHospitalAccountList() {
      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage; // 페이지네이션 관련 변수
      obj.type = this.type;
      if (this.searchFilter) obj.search = this.searchFilter;
      if (this.condition) obj.condition = this.condition;
      if (this.sort) obj.sort = this.sort;
      if (this.accountTypeFilter) obj.accountType = this.accountTypeFilter;

      try {
        const response = await this.$apiInstance.post(`/accounts/list`, obj);
        if (response.status === 200 || response.status === 201) {
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize -
              i -
              (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getHospitalAccountList();
    },
    // 계정 연결해제
    async logoutUser() {
      try {
        // companyId, username
        const obj = {};
        obj.companyId = this.selectedHospital.companyId;
        obj.username = this.selectedHospital.username;

        const response = await this.$apiInstance.post(
          `/accounts/target/logout`,
          obj
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "해당 계정이 로그아웃 처리되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        } else {
          await openDialog("로그아웃에 실패하였습니다.", "error", "확인");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async resetPassword() {
      try {
        const response = await this.$apiInstance.put(
          `/companies/resetPassword/${this.selectedHospital._id}`
        );
        if (response.status === 200 || response.status === 201) {
          await openDialog(
            "비밀번호가 초기화되었습니다.",
            "success",
            "확인"
          ).then(() => {
            location.reload();
          });
        }
      } catch (error) {
        console.log(error);
        await openDialog("비밀번호가 초기화에 실패했습니다.", "error", "확인");
      }
    },
    // 엑셀 다운로드
    async downloadExcel() {
      const year = new Date().getFullYear();
      const month = String(new Date().getMonth() + 1).padStart(2, "0");
      const day = String(new Date().getDate()).padStart(2, "0");

      const formattedDate = `${year}${month}${day}`;
      try {
        // accountType 필터가 있으면 쿼리 파라미터에 추가
        const params = {};
        if (this.accountTypeFilter) {
          params.accountType = this.accountTypeFilter;
        }

        const response = await this.$apiInstance.get(
          `/accounts/excels/${this.type}`,
          {
            params,
            headers: {
              "Content-Type": "octet-stream",
            },
            responseType: "blob",
          }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = `병원계정_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
        } else {
          // Handle the error case
        }
      } catch (error) {
        console.error("Error downloading Excel file:", error);
      }
    },

    // 페이지네이션

    // 기타 HosAccManage용 utils

    // 날짜, 시간 포맷에 맞추기
    convertDate,

    // 계정 유형 라벨 반환
    getAccountTypeLabel(accountType) {
      switch (accountType) {
        case "ADMIN":
          return "관리자";
        case "MEMBER":
          return "서브";
        default:
          return "관리자"; // 기존 계정은 기본적으로 관리자로 표시
      }
    },

    // 보기, 수정, 삭제 시 선택
    selectHospital(hospital) {
      this.selectedHospital = hospital;
    },

    async editHospital(record) {
      console.log("수정할 병원 계정:", record);
      this.editedRecord = record;
      this.formEdit.username = record.username;
      this.formEdit.newPassword = "";
      this.formEdit.confirmPassword = "";
      this.formEdit.allowedCategories = record.allowedCategories || [];
      this.availableCategories = {};
      this.editModalVisible = true;

      // 서브계정인 경우 상세 정보 조회하여 선택 가능한 권한 목록 가져오기
      if (record.accountType === "MEMBER") {
        this.editDetailLoading = true;
        try {
          const response = await this.$apiInstance.get(
            `/accounts/detail/${record._id}`
          );
          if (response.status === 200 || response.status === 201) {
            this.availableCategories = response.data.availableCategories || {};
            // 기존 선택된 권한 설정
            this.formEdit.allowedCategories =
              response.data.allowedCategories || [];
          }
        } catch (error) {
          console.error("계정 상세 조회 실패:", error);
        } finally {
          this.editDetailLoading = false;
        }
      }
    },
    async confirmEdit() {
      // 유효성 검사
      if (!this.isFormValid) {
        return;
      }

      // API 호출 전 로딩 시작
      this.editLoading = true;

      try {
        // API 파라미터 구성
        const requestBody = {
          newUsername: this.formEdit.username,
        };

        // 비밀번호가 입력된 경우에만 파라미터에 추가
        if (
          this.formEdit.newPassword &&
          this.formEdit.newPassword.trim() !== ""
        ) {
          requestBody.newPassword = this.formEdit.newPassword;
        }

        // 서브계정인 경우 권한 정보 추가
        if (this.editedRecord.accountType === "MEMBER") {
          requestBody.allowedCategories = this.formEdit.allowedCategories;
        }

        // 변경사항이 있는지 확인
        const hasUsernameChange =
          this.formEdit.username !== this.editedRecord.username;
        const hasPasswordChange =
          this.formEdit.newPassword && this.formEdit.newPassword.trim() !== "";

        // 권한 변경 여부 확인 (서브계정인 경우)
        const hasPermissionChange =
          this.editedRecord.accountType === "MEMBER" &&
          JSON.stringify(this.formEdit.allowedCategories.sort()) !==
            JSON.stringify((this.editedRecord.allowedCategories || []).sort());

        if (!hasUsernameChange && !hasPasswordChange && !hasPermissionChange) {
          this.editLoading = false;
          // 서브계정인 경우 메시지 표시 후 모달 닫기
          if (this.editedRecord.accountType === "MEMBER") {
            await openDialog(
              "변경 사항이 없어 수정이 닫힙니다.",
              "info",
              "확인"
            );
            this.cancelEdit();
          } else {
            await openDialog("변경사항이 없습니다.", "warning", "확인");
          }
          return;
        }

        // API 호출
        await this.$apiInstance.put(
          `/accounts/username/${this.editedRecord._id}`,
          requestBody
        );

        this.editLoading = false;
        this.editModalVisible = false;

        // 성공 메시지 구성
        let message = "수정이 완료되었습니다.";
        const changes = [];
        if (hasUsernameChange) changes.push("관리자 ID");
        if (hasPasswordChange) changes.push("비밀번호");
        if (hasPermissionChange) changes.push("권한");

        if (changes.length > 0) {
          message = `${changes.join(", ")}이(가) 변경되었습니다.`;
        }

        await openDialog(message, "success", "확인");
        location.reload();
      } catch (error) {
        this.editLoading = false;
        console.error(error);
        await openDialog("수정에 실패했습니다.", "error", "확인");
      }
    },
    cancelEdit() {
      this.editModalVisible = false;
      this.formEdit.username = "";
      this.formEdit.newPassword = "";
      this.formEdit.confirmPassword = "";
      this.formEdit.allowedCategories = [];
      this.availableCategories = {};
    },
    // 권한 체크박스 변경 핸들러
    handlePermissionChange(code, checked) {
      if (checked) {
        // 체크된 경우 배열에 추가 (중복 방지)
        if (!this.formEdit.allowedCategories.includes(code)) {
          this.formEdit.allowedCategories.push(code);
        }
      } else {
        // 체크 해제된 경우 배열에서 제거
        const index = this.formEdit.allowedCategories.indexOf(code);
        if (index > -1) {
          this.formEdit.allowedCategories.splice(index, 1);
        }
      }
    },
    handleUsernameChange() {
      // 새 관리자 ID가 비어있지 않은 경우에만 에러 제거
      if (this.formEdit.username && this.formEdit.username.trim() !== "") {
        this.$refs.editForm.clearValidate("username");
      }
    },
  },
};
</script>
<style scoped>
/* 지원 서브 계정 행 배지(W6 A6) */
.support-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f0f2f5;
  color: #5c6168;
  font-size: 12px;
  white-space: nowrap;
}
.modal-title {
  font-size: 16px;
  font-weight: bold;
}

.modal-content {
  padding: 20px;
  border: none;
  background: #fff;

  :deep(.ant-form-item) {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
}

.password-section {
  margin-top: 8px;
}

.password-hint {
  margin-top: 8px;
}

.password-error {
  margin-top: 4px;
}

.permission-section {
  margin-top: 8px;
}

.permission-groups {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.permission-group {
  background: #f9fafb;
  border-radius: 8px;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
}

.permission-group-title {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.permission-group-items {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
}

.permission-item {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.15s ease;
  min-width: calc(50% - 6px);

  &:hover {
    background-color: #f3f4f6;
  }

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    cursor: pointer;
    accent-color: #ffcc32;
    flex-shrink: 0;
  }
}

.permission-label {
  font-size: 13px;
  color: #374151;
  user-select: none;
  white-space: nowrap;
}

.no-permissions {
  text-align: center;
  color: #9ca3af;
  padding: 24px;
}

:deep(.ant-modal) {
  padding-bottom: 0;

  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

    .ant-modal-close {
      color: rgba(0, 0, 0, 0.45);
    }

    .ant-modal-header {
      padding: 16px 20px;
      border: none;
      background: #fff;
      margin: 0;
    }

    .ant-modal-body {
      padding: 0;
      background: #fff;
      border: none;
    }

    .ant-modal-header,
    .ant-modal-body,
    .ant-modal-footer {
      border: none;
    }
  }
}
</style>
